/**
 * PDP gallery: serving (single|double) × purchase (subscribe|onetime)
 * → slide from [data-brs-purchase-type-media] metafield map.
 */
;(function () {
  var ATTR = 'data-brs-purchase-gallery'

  function deepQuery(root, selector, out) {
    if (!root) return out
    if (root.nodeType === 1 && root.shadowRoot) deepQuery(root.shadowRoot, selector, out)
    try {
      if (root.querySelectorAll) {
        root.querySelectorAll(selector).forEach(function (el) {
          out.push(el)
        })
      }
    } catch (_) {}
    var kids = root.children
    if (!kids) return out
    for (var i = 0; i < kids.length; i++) {
      deepQuery(kids[i], selector, out)
      if (kids[i].shadowRoot) deepQuery(kids[i].shadowRoot, selector, out)
    }
    return out
  }

  function visible(el) {
    if (!el || !el.isConnected) return false
    for (var n = el; n && n !== document.documentElement; n = n.parentElement) {
      if (n.hidden) return false
      var st = window.getComputedStyle(n)
      if (st.display === 'none' || st.visibility === 'hidden') return false
    }
    return true
  }

  function textOf(el) {
    return String((el && el.textContent) || '').replace(/\s+/g, ' ').trim()
  }

  function isSubscribeText(t) {
    return /subscribe/i.test(t) && !/^one[-\s]?time/i.test(t)
  }

  function isOnetimeText(t) {
    return /one[-\s]?time/i.test(t)
  }

  function isSelected(el) {
    if (!el) return false
    var radio = el.closest('[role="radio"]') || (el.getAttribute('role') === 'radio' ? el : null)
    if (radio) {
      var ac = radio.getAttribute('aria-checked')
      if (ac === 'true') return true
      if (ac === 'false') return false
    }
    if (el.getAttribute('aria-checked') === 'true') return true
    if (el.closest('[aria-checked="true"]')) return true
    if (el.querySelector && el.querySelector('input:checked')) return true
    if (/is-selected|selected|checked|active/i.test(String(el.className || ''))) return true
    return false
  }

  function fileStem(url) {
    if (!url) return ''
    var file = String(url).split('?')[0].split('/').pop() || ''
    return file
      .toLowerCase()
      .replace(/_\d+x(\.[^.]+)$/i, '$1')
      .replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|original|master)(\.[^.]+)$/i,
        '$2'
      )
  }

  function normalizeUrl(url) {
    var s = String(url || '').trim()
    if (!s) return ''
    return s.indexOf('//') === 0 ? 'https:' + s : s
  }

  function parseEntry(v) {
    if (v == null || v === '') return { id: '', url: '' }
    if (typeof v === 'object') {
      return {
        id: v.id != null && String(v.id) !== 'null' ? String(v.id).trim() : '',
        url: normalizeUrl(v.url),
      }
    }
    var s = String(v).trim()
    if (!s || s === 'null') return { id: '', url: '' }
    if (/^https?:\/\//i.test(s) || s.indexOf('//') === 0) return { id: '', url: normalizeUrl(s) }
    return { id: s, url: '' }
  }

  function getGallery(sectionId) {
    return document.querySelector('product-images[data-section-id="' + sectionId + '"]')
  }

  function getConfig(sectionId) {
    var gallery = getGallery(sectionId)
    var el = gallery && gallery.querySelector('[data-brs-purchase-type-media]')
    if (!el || !el.textContent) return null
    try {
      var c = JSON.parse(el.textContent)
      return {
        single_subscribe: parseEntry(c.single_subscribe),
        double_subscribe: parseEntry(c.double_subscribe),
        single_onetime: parseEntry(c.single_onetime),
        double_onetime: parseEntry(c.double_onetime),
      }
    } catch (_) {
      return null
    }
  }

  function entryReady(e) {
    return !!(e && (e.id || e.url))
  }

  function configReady(c) {
    return !!(
      c &&
      (entryReady(c.single_subscribe) ||
        entryReady(c.double_subscribe) ||
        entryReady(c.single_onetime) ||
        entryReady(c.double_onetime))
    )
  }

  function readServing(section) {
    var pressed = section.querySelector(
      '.brs-format-serving__item[data-serving-choice][aria-pressed="true"]'
    )
    var choice = pressed && pressed.getAttribute('data-serving-choice')
    if (choice === 'single' || choice === 'double') return choice
    var card = section.querySelector('.brs-format-serving__card.is-selected')
    var item = card && card.closest('[data-serving-choice]')
    choice = item && item.getAttribute('data-serving-choice')
    return choice === 'double' ? 'double' : 'single'
  }

  function readIsOnetime(section) {
    var nodes = []
    deepQuery(section, 'label', nodes)
    deepQuery(section, '[role="radio"]', nodes)

    var sawSub = false
    var sawOt = false
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i]
      if (!visible(el)) continue
      var t = textOf(el)
      if (!t || t.length > 500) continue
      if (!isSubscribeText(t) && !isOnetimeText(t)) continue
      if (!isSelected(el)) continue
      if (isOnetimeText(t)) sawOt = true
      if (isSubscribeText(t)) sawSub = true
    }
    if (sawOt && !sawSub) return true
    if (sawSub && !sawOt) return false

    var form = document.getElementById('product-form-' + section.dataset.sectionId)
    if (form) {
      var plan = form.querySelector(
        'input[name="selling_plan"], select[name="selling_plan"], input.selling_plan-id'
      )
      if (plan) return String(plan.value || '').trim() === ''
    }
    return false
  }

  function findSlideByUrl(gallery, url) {
    var stem = fileStem(url)
    if (!gallery || !stem) return null

    var slides = gallery.querySelectorAll('.product-main-slide')
    for (var i = 0; i < slides.length; i++) {
      var imgs = slides[i].querySelectorAll('img[src], img[srcset], source[srcset]')
      for (var j = 0; j < imgs.length; j++) {
        var src = imgs[j].getAttribute('src') || ''
        var srcset = imgs[j].getAttribute('srcset') || ''
        if (fileStem(src) === stem || srcset.toLowerCase().indexOf(stem) !== -1) {
          return slides[i]
        }
      }
    }

    var thumbs = gallery.querySelectorAll('.product__thumb-item a[href], .product__thumb img[src]')
    for (var t = 0; t < thumbs.length; t++) {
      var el = thumbs[t]
      if (fileStem(el.getAttribute('href') || el.getAttribute('src') || '') !== stem) continue
      var item = el.closest('.product__thumb-item')
      var index = item && item.getAttribute('data-index')
      if (index != null) {
        return gallery.querySelector('.product-main-slide[data-index="' + index + '"]')
      }
    }
    return null
  }

  function selectMedia(sectionId, entry, combo) {
    var gallery = getGallery(sectionId)
    if (!gallery) return false

    var mediaId = entry && entry.id
    var slide =
      (combo && gallery.querySelector('.product-main-slide[data-brs-combo="' + combo + '"]')) ||
      (mediaId && gallery.querySelector('.product-main-slide[data-media-id="' + mediaId + '"]')) ||
      findSlideByUrl(gallery, entry && entry.url)

    if (!slide) return false

    var index = slide.getAttribute('data-index')
    var thumb =
      gallery.querySelector('.product__thumb-item[data-index="' + index + '"] [data-product-thumb]') ||
      gallery.querySelector('.product__thumb-item[data-index="' + index + '"] a')

    if (thumb) {
      thumb.click()
      return true
    }

    gallery.dispatchEvent(
      new CustomEvent('brs:go-to-slide', {
        detail: {
          mediaId: String(mediaId || slide.getAttribute('data-media-id') || ''),
          index: index,
        },
        bubbles: false,
      })
    )
    return true
  }

  function apply(section) {
    var config = getConfig(section.dataset.sectionId)
    if (!configReady(config)) return false

    var serving = readServing(section)
    var isOnetime = readIsOnetime(section)
    var combo = (serving === 'double' ? 'double' : 'single') + '_' + (isOnetime ? 'onetime' : 'subscribe')
    var entry = config[combo]
    if (!entryReady(entry)) return false

    return selectMedia(section.dataset.sectionId, entry, combo)
  }

  function applySoon(section) {
    apply(section)
    ;[200, 600, 1200].forEach(function (ms) {
      setTimeout(function () {
        apply(section)
      }, ms)
    })
  }

  function attach(section) {
    if (!section || section.getAttribute(ATTR)) return
    if (!configReady(getConfig(section.dataset.sectionId))) return

    section.setAttribute(ATTR, '')

    section.addEventListener(
      'click',
      function (e) {
        var t = e.target
        if (!t || !t.closest) return
        if (t.closest('.brs-format-serving__item[data-serving-choice]')) {
          applySoon(section)
          return
        }
        var hit = t.closest('label, [role="radio"], button')
        var txt = textOf(hit || t).slice(0, 280)
        if (isSubscribeText(txt) || isOnetimeText(txt)) applySoon(section)
      },
      true
    )

    window.addEventListener('brocshot:purchase-type', function (ev) {
      if (!ev.detail || String(ev.detail.sectionId) !== String(section.dataset.sectionId)) return
      applySoon(section)
    })

    window.addEventListener('brs:purchase-gallery-refresh', function (ev) {
      if (!ev.detail || String(ev.detail.sectionId) !== String(section.dataset.sectionId)) return
      applySoon(section)
    })

    applySoon(section)
  }

  function boot() {
    document.querySelectorAll('section.page-content--product[data-section-id]').forEach(attach)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }

  document.addEventListener('shopify:section:load', function () {
    requestAnimationFrame(boot)
  })
})()
